<template>
  <div>
    <b-modal id="addNewUser" size="lg" class="modal has-overflow">
      <template v-slot:modal-header>
        <div class="w-100">
          <h4 class="e-mtavr-17 e-bold modal-title">ახალი მომხმარებელი</h4>
        </div>
      </template>
      <form autocomplete="off">
        <div class="row no-gutters row-bordered">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pr-3">
             <h5
                class="text-center py-4 px-4 px-sm-5 m-0 e-mtavr-14 text-muted"
              >პირადი მონაცემები</h5>
              <hr class="border-light m-0 mb-3" />
            <b-form-group
              label="სახელი"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="newUserItem.user.firstName" class="e-eng-font" />
            </b-form-group>
            <b-form-group
              label="გვარი"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="newUserItem.user.lastName" class="e-eng-font" />
            </b-form-group>
            <b-form-group label="პოზიცია" class="e-nusx-8 e-bold text-muted">
            <b-select value="აირჩიეთ პოზიცია" v-model="newUserItem.user.positionID" :options="positions" disabled />
          </b-form-group>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-3">
            <h5
                class="text-center py-4 px-4 px-sm-5 m-0 e-mtavr-14 text-muted"
              >სისტემური პარამეტრები</h5>
              <hr class="border-light m-0 mb-3" />
              <b-form-group label="მომხმარებლის სახელი" class="e-nusx-8 text-muted">
            <b-input-group>
              <b-input placeholder="username" name="aadd" type="text" @focusout="CheckUsername()" v-model="newUserItem.user.userName" autocomplete="nope"/>
              <b-btn slot="append" class="e-nusx-8 e-ts-07rem" :class="[usernameChecked ? (usernameIsValid ? 'btn-success' : 'btn-danger') : '' ]" :disabled="newUserItem.user.userName === ''" @click="CheckUsername()"><span class="lnr lnr-checkmark-circle" v-if="usernameChecked && usernameIsValid"> <i class="e-nusx-8"> დასაშვებია</i></span><span class="lnr lnr-cross-circle" v-else-if="usernameChecked === true && usernameIsValid === false"><i class="e-nusx-8"> დაკავებულია</i></span><span v-else>შეამოწმე</span></b-btn>
            </b-input-group>
          </b-form-group>
              <b-form-group
              label="მომხმარებლის პაროლი"
              class="e-nusx-8 e-bold text-muted"
            >
             <b-input-group>
              <b-input placeholder="" type="password" v-model="newUserItem.user.password"/>
              <b-btn slot="append" class="e-nusx-8 e-ts-07rem" :disabled="!usernameChecked || newUserItem.user.userName === ''" @click="GenerateStandartPassword()">სტანდარტული</b-btn>
            </b-input-group>
            </b-form-group>
<b-form-group
              label="გაიმეორეთ პაროლი"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="newUserItem.user.rePassword" class="e-eng-font"/>
            </b-form-group>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
            <div class="callout callout-primary" v-if="standartPasswordGenerated">
              <h5 class="e-nusx-8 e-bold"><i><small>შენიშვნა</small></i></h5>
              <p class="e-nusx-8"><small>გაცნობებთ, რომ თქვენს მიერ მოხდა მომხმარებლისთვის სტანდარტული პაროლის გენერაცია. რეკომენდირებულია მომხმარებელმა შეცვალოს პაროლი პირველივე შესვლისას</small></p>
              <hr>
              <p class="e-nusx-8">დაგენერირებული პაროლი: <strong> {{newUserItem.user.password}}</strong></p>
            </div>
          </div>
        </div>
      </form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            variant="btn btn-primary"
            @click="save()"
            class="float-right e-mtavr-17"
            >შენახვა</b-button
          >
          <b-button
            size="sm"
            variant="btn btn-secondary"
            @click="close('addNewUser')"
            class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import moment from 'moment'
export default {
  name: 'AddNewUserModal',
  data () {
    return {
      usernameIsValid: undefined,
      usernameChecked: undefined,
      standartPasswordGenerated: false,
      // currentUser: this.$store.getters.GetCurrentUser,
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      newUserItem: {
        user: {
          id: 0,
          userName: '',
          password: '',
          firstName: '',
          lastName: '',
          statusID: 8,
          positionID: 1008,
          organizationID: 0,
          registrationDate: moment(Date.now()).format()
        },
        modules: [{
          id: 11,
          name: '',
          shortName: '',
          shortDescription: '',
          description: '',
          symbolCode: '',
          colorCode: '',
          moduleUrl: '',
          brnColorCode: ''
        }]
      },
      positions: [
        {
          value: null,
          text: 'აირჩიეთ პოზიცია'
        },
        {
          value: 1008,
          text: 'AML სისტემის ადმინისტრატორი'
        },
        {
          value: 1009,
          text: 'AML ჯგუფის უფროსი'
        },
        {
          value: 1010,
          text: 'AML ოფიცერი'
        },
        {
          value: 1011,
          text: 'AML მომხმარებელი'
        }
      ]
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    }
  },
  created () {},
  methods: {
    CheckUsername () {
      if (this.newUserItem.user.userName) {
        BaseService.ValidateUsername(this.header, this.newUserItem.user.userName)
          .then(res => {
            if (res.data.success === true && res.data.result === true) {
              this.usernameIsValid = true
              this.usernameChecked = true
            } else if (res.data.success === true && res.data.result === false) {
              this.usernameIsValid = false
              this.usernameChecked = true
            } else {
              this.usernameIsValid = false
              this.usernameChecked = false
            }
          })
      } else {
        this.usernameIsValid = false
        this.usernameChecked = false
      }
    },
    GenerateStandartPassword () {
      this.newUserItem.user.password = Math.random().toString(36).slice(-8)
      this.newUserItem.user.rePassword = this.newUserItem.user.password
      this.standartPasswordGenerated = true
    },
    CheckPasswordStrength () {},
    save () {
      this.newUserItem.user.organizationID = this.currentUser.organizationID
      BaseService.AddUser(this.header, this.newUserItem)
        .then(res => {
          if (res.data.success) {
            this.newUserItem = {
              user: {
                id: 0,
                userName: '',
                password: '',
                firstName: '',
                lastName: '',
                statusID: 8,
                positionID: 0,
                organizationID: 0,
                registrationDate: moment(Date.now()).format()
              },
              modules: [{
                id: 11,
                name: '',
                shortName: '',
                shortDescription: '',
                description: '',
                symbolCode: '',
                colorCode: '',
                moduleUrl: '',
                brnColorCode: ''
              }]
            }
            this.$bvModal.hide('addNewUser')
          }
        })
    },
    close (id) {
      this.newUserItem = {
        user: {
          id: 0,
          userName: '',
          password: '',
          firstName: '',
          lastName: '',
          statusID: 8,
          positionID: 0,
          organizationID: 0,
          registrationDate: moment(Date.now()).format()
        },
        modules: [{
          id: 11,
          name: '',
          shortName: '',
          shortDescription: '',
          description: '',
          symbolCode: '',
          colorCode: '',
          moduleUrl: '',
          brnColorCode: ''
        }]
      }
      this.$bvModal.hide(id)
    }
  }
}
</script>

<style>
</style>
